import React from 'react';
import CardDrawingSystem from './components/CardDrawingSystem';
import SquadTacticsGame from './components/MapSetup';

function App() {
  return (
    <div className="App">
      <CardDrawingSystem/>
    </div>
  );
}

export default App;